import { useState, useEffect, useCallback, useRef } from 'react';

export function useHeader() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [activeSection, setActiveSection] = useState('home');
  const isScrollingRef = useRef(false);

  const toggleMenu = useCallback(() => setMenuOpen((prev) => !prev), []);
  const closeMenu = useCallback(() => setMenuOpen(false), []);

  const scrollToSection = useCallback(
    (id) => {
      const section = document.getElementById(id);
      if (!section) return;

      const headerHeight = parseInt(
        getComputedStyle(document.documentElement).getPropertyValue('--header-height')
      ) || 110;

      const top = section.offsetTop - headerHeight + 1;

      isScrollingRef.current = true; 
      window.scrollTo({ top, behavior: 'smooth' });
      setActiveSection(id);
      closeMenu();

      // Re-enable scroll detection after smooth scroll
      setTimeout(() => {
        isScrollingRef.current = false;
      }, 500); // 500ms matches scroll animation duration
    },
    [closeMenu]
  );

  useEffect(() => {
    const sections = ['home', 'services', 'projects', 'about', 'contact'];

    const handleScroll = () => {
      if (isScrollingRef.current) return; // ignore during manual scroll

      const headerHeight = parseInt(
        getComputedStyle(document.documentElement).getPropertyValue('--header-height')
      ) || 110;

      const scrollY = window.scrollY + headerHeight + 5;

      for (let i = sections.length - 1; i >= 0; i--) {
        const section = document.getElementById(sections[i]);
        if (section && scrollY >= section.offsetTop) {
          if (activeSection !== sections[i]) {
            setActiveSection(sections[i]);
          }
          break;
        }
      }
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [activeSection]);

  return {
    menuOpen,
    toggleMenu,
    closeMenu,
    activeSection,
    scrollToSection
  };
}
